/* External */
import { fromJS } from 'immutable';

/* Ott Common */
import backendService from '../../services/backendService';

/* Utils */
import { NEW_TERMS_COUNTRIES } from '../../utils/env';
import aemService from '../../services/aemService';
import { mergeDeepWithLists } from '../../utils/functions';
import { resolveWhenConnectionAvailable } from '../ConnectionStatusProvider';

export async function getTermsOfService(country) {
  await resolveWhenConnectionAvailable();
  const termsOfService = await aemService.termsOfService.getAllTermsOfServiceByCountry(country);
  return termsOfService.data;
}

export function mergePrevAndNewTerms(prev, newTerms) {
  if (!prev) return fromJS(newTerms);

  return mergeDeepWithLists(prev, newTerms);
}

function shouldVerifyLegal(country) {
  return NEW_TERMS_COUNTRIES.has(country);
}

export async function shouldUserAcceptNewTerms(country) {
  try {
    const verifyLegal = shouldVerifyLegal(country);
    const {
      data: {
        legalTerms: { shouldShowTermsAndConditions, shouldShowPrivacyPolicy },
      },
    } = await backendService.customer.v1.checkEligibility(verifyLegal);

    return shouldShowTermsAndConditions || shouldShowPrivacyPolicy;
  } catch (error) {
    console.error('shouldUSerAcceptNewTerms', error);
    throw error;
  }
}
